const STORAGE_KEY = "nexus.marketplace.recentVendors";
const MAX_RECENT_VENDORS = 5;

export function readRecentVendorIds(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === "string").slice(0, MAX_RECENT_VENDORS);
  } catch {
    return [];
  }
}

export function rememberRecentVendor(vendorId: string): string[] {
  const next = [vendorId, ...readRecentVendorIds().filter((id) => id !== vendorId)].slice(
    0,
    MAX_RECENT_VENDORS,
  );
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // private browsing / storage denied — still return the in-memory list
    }
  }
  return next;
}
